import * as angular from 'angular';

import { V2_CHART_OPTION_TYPES } from '~/common/constants';
import { ChartTypes } from '@mode/shared/contract-common';

class ViewerEmptyChartStateController {
  chartType: ChartTypes.ChartType;
  vizErrorType: string;
  emptyCopy: string;
  reportEditLink: string;
  isValid: boolean;

  constructor() {}

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.chartType && changes.chartType.currentValue) {
      const vizTypeConstants = V2_CHART_OPTION_TYPES.find((type) => type.id === this.chartType);
      if (vizTypeConstants) {
        this.emptyCopy = this.chartType === 'vegas' ? 'visualization' : vizTypeConstants.name.toLowerCase();
        this.vizErrorType = vizTypeConstants.errorSvgKey;
      } else {
        this.emptyCopy = 'visualization';
        this.vizErrorType = 'error-line';
      }
    }
  }
}

export const ID = 'viewerEmptyChart';

export const ViewerEmptyChartStateComponent: angular.IComponentOptions = {
  bindings: {
    chartType: '<',
    isValid: '<',
    isComplete: '<',
    reportEditLink: '<',
  },
  controller: ViewerEmptyChartStateController,
  controllerAs: 'ctrl',
  template: `
  <div class="chart-placeholder">
    <div class="empty-chart-state" ng-if="!ctrl.isComplete && ctrl.isValid">
      <svg-icon type="'empty-exploration'"></svg-icon>
      <h2>This Exploration is still in progress</h2>
      <p>The underlying visualization hasn't been configured yet.</p>
    </div>
    <div class="empty-chart-state query-error" ng-if="ctrl.isComplete && !ctrl.isValid">
      <svg-icon type="ctrl.vizErrorType"></svg-icon>
      <h2>Sorry, this {{ ctrl.emptyCopy }} can't be displayed with the data provided.</h2>
    </div>
  </div>`,
};
